export default "__VITE_ASSET__1ac210af__"